import { useEffect } from 'react';

const addFreshworksScripts = () => {
  if (typeof window !== 'undefined') {
    if (!document.getElementById('freshworks-script-1')) {
      const script1 = document.createElement('script');
      script1.id = 'freshworks-script-1';
      script1.innerHTML = `
        window.fwSettings = { 'widget_id': 1000000555 };
        !function() {
          if (typeof window.FreshworksWidget !== "function") {
            var n = function() { n.q.push(arguments); };
            n.q = [];
            window.FreshworksWidget = n;
          }
        }();
      `;
      document.head.appendChild(script1);
    }

    if (!document.getElementById('freshworks-script-2')) {
      const script2 = document.createElement('script');
      script2.id = 'freshworks-script-2';
      script2.type = 'text/javascript';
      script2.src = 'https://widget.freshworks.com/widgets/1000000555.js';
      script2.async = false;
      script2.defer = false;
      document.head.appendChild(script2);
    }
  }
};

const removeFreshworksScripts = () => {
  if (typeof window !== 'undefined') {
    const script1 = document.getElementById('freshworks-script-1');
    if (script1) {
      script1.parentNode?.removeChild(script1);
    }

    const script2 = document.getElementById('freshworks-script-2');
    if (script2) {
      script2.parentNode?.removeChild(script2);
    }

    const containers = document.querySelectorAll('#freshworks-container');
    if (containers) {
      containers.forEach(container => {
        if (container.parentNode) {
          container.parentNode.removeChild(container);
        }
      });
    }
  }
};

const useFreshworks = () => {
  useEffect(() => {
    window.useFreshworks = () => {
      addFreshworksScripts();
      window.FreshworksWidget('open');
    };

    return () => {
      removeFreshworksScripts();
    };
  }, []);
};

export default useFreshworks;
